import React from "react";
import Button from "@src/components/UIElements/Button";
import styles from "../../styles/TestStatsCard.module.scss";
import { Image } from "@src/components/Image";
import { getAwsAssets } from "@src/utils";
import { t } from "i18next";
import { CONTENT_DEEPLINK_ACTIONS, TEST_TYPE } from "../../store/constants";
import { hitContentDeeplinkOld } from "../../helpers/hitContentDeeplink";
import getSubmissionTimeFormat from "@src/utils/getSubmissionTimeFormat";
import { getSubjectiveTestDownloadUrlService } from "../../store/services";
import { useSelector } from "react-redux";

const TestStatsCard = ({
  cardHeading,
  scoredMarks,
  maxMarks,
  maxScoredMarks,
  timeTaken,
  avgTimeTaken,
  rank,
  projectedRank,
  projectedRankDiff,
  projectedRankUp,
  yourGrade,
  solutionUrl,
  solutionUrlText,
  submissionTime,
  viewSubmissionText,
  viewSubmissionUrl,
  testId,
  studentTestId,
  onViewStats,
  isViewStatsLoading,
  testStats,
}) => {
  // VIEW TEST REPORT DEEPLINK HIT
  const viewTestReportDeeplink = (solutionUrl) => {
    const paramObj = {
      paramOne: solutionUrl,
    };
    hitContentDeeplinkOld(CONTENT_DEEPLINK_ACTIONS.UTIL_TEST, paramObj);
    // window?.mobile?.onDeeplinkExecutedV2(deeplinkObject);
  };

  const testStatesData =  useSelector((state) => state?.courseContentReducer?.apiResGET_COURSE_CONTENT_TEST_STATS) || {};


  const viewSubmissionDeeplink = async (content) => {
    try {
      let submissionUrl = content?.url;
      if (!submissionUrl) {
        const data = await getSubjectiveTestDownloadUrlService({ studentTestId: content?.studentTestId, testId: content?.testId, type: "solution" });
        if (data?.status == 200) {
          submissionUrl = data?.data?.data?.downloadUrl;
        }
      }
      if(submissionUrl) {
        let url = {
          screen: `SCREEN_CONTENT`,
          paramOne: submissionUrl,
          paramTwo: content?.name,
          paramThree: content?.description,
        };
        window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify(url)
        );
      }
    } catch (error) {
        console.log("error", error);
        toast.error(
          t(
            "components.tabs.content.components.testStats.testStatsCard.somethingWrongErrorText",
            "Something went wrong..., Please try again."
          )
        );
    }
  };

  return (
    <div className={styles.testStatsCard}>
      <div className={styles.testStatsCard__separator}></div>
      {scoredMarks || scoredMarks === 0 || testStats?.testFormat === 2 ? null : (
        <div className={styles.testStatsCard__evalLabel}>
          {t(
            "components.tabs.content.components.testStats.testStatsCard.resultInEvaluationText",
            "Result will be shown after your answers are evaluated"
          )}
        </div>
      )}
      {cardHeading && (
        <h1 className={styles.testStatsCard__heading}>{cardHeading}</h1>
      )}
      <div className={styles.testStatsCard__card}>
        {scoredMarks || scoredMarks === 0 ? (
          <div className={styles.testStatsCard__card__cardDetails}>
            {(scoredMarks || scoredMarks === 0) && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.yourScoreText",
                    "Your score"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {scoredMarks}
                  <span>/{maxMarks}</span>
                </div>
              </div>
            )}
            {(maxScoredMarks || maxScoredMarks === 0) && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.highestScoreText",
                    "Highest score"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {maxScoredMarks}
                  <span>/{maxMarks}</span>
                </div>
              </div>
            )}
            {timeTaken && testStatesData?.testFormat !== 2 && ( 
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.timeTakenText",
                    "Time taken"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {timeTaken}
                </div>
              </div>
            )}
            {avgTimeTaken && testStatesData?.testFormat !== 2 && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.avgTimeTakenText",
                    "Avg. time taken"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {avgTimeTaken}
                </div>
              </div>
            )}
            {rank && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.yourRankText",
                    "Your rank"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {rank}
                </div>
              </div>
            )}
            {projectedRank && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.projectedRankText",
                    "Projected rank"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {projectedRank} <span>{projectedRankDiff}</span>{" "}
                  <Image
                    src={getAwsAssets(
                      projectedRankUp
                        ? "greenTriangleUp.svg"
                        : "redTriangleDown.svg",
                      "content"
                    )}
                    alt="projectedRankIcon"
                    width={12}
                    height={10}
                  />
                </div>
              </div>
            )}
            {yourGrade && testStatesData?.testFormat !== 2 && (
              <div className={styles.testStatsCard__card__cardDetails__item}>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__title
                  }
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.yourGradeText",
                    "Your grade"
                  )}
                </div>
                <div
                  className={
                    styles.testStatsCard__card__cardDetails__item__content
                  }
                >
                  {yourGrade}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.testStatsCard__card__testSubmitted}>
            <div
              className={styles.testStatsCard__card__testSubmitted__tickIcon}
            >
              <Image
                src={getAwsAssets("tickIcon.svg", "content")}
                alt="tickIcon"
                height={22}
                width={17}
              />
            </div>
            <h4>
              {t(
                "components.tabs.content.components.testStats.testStatsCard.answersSubmittedHeading",
                "Answers Submitted"
              )}
            </h4>
            <p>
              {t(
                "components.tabs.content.components.testStats.testStatsCard.answersSubmittedPara",
                "Your answers for this test have been submitted successfully"
              )}
            </p>
            {!!submissionTime && <p>
              {t(
                "components.tabs.content.components.testStats.testStatsCard.submittedOnText",
                "Submitted on"
              )}{" "}
              {getSubmissionTimeFormat(submissionTime)}
            </p>}
          </div>
        )}
        <div className={styles.testStatsCard__card__buttonGroup}>
          {viewSubmissionText ? (
            <div className={styles.testStatsCard__card__button}>
              <Button
                filled
                padding6
                outline
                onClick={() => viewSubmissionDeeplink({
                  url: viewSubmissionUrl,
                  name: "Submission",
                  description: "",
                  testId: testId,
                  studentTestId: studentTestId,
                })}
                customClassName={styles.testStatsCard__card__button}
              >
                {viewSubmissionText}
              </Button>
            </div>
          ) : null}
          {solutionUrl && solutionUrlText ? (
            <div className={styles.testStatsCard__card__button}>
              <Button
                filled
                padding6
                onClick={() => viewTestReportDeeplink(solutionUrl)}
                customClassName={styles.testStatsCard__card__button}
              >
                {solutionUrlText}

              </Button>
            </div>
          ) : null}
          {!!testStats?.rank && testStats?.typeOfTest === TEST_TYPE.SUBJECTIVE_TEST &&
             (<div className={styles.testStatsCard__card__button}>
                <Button
                  filled
                  padding6
                  outline
                  onClick={onViewStats}
                  customClassName={styles.testStatsCard__card__button}
                  disabled={isViewStatsLoading}
                >
                  {t(
                    "components.tabs.content.components.testStats.testStatsCard.viewLeaderboardText",
                    "View Leaderboard"
                  )}
                </Button>
            </div>)}
        </div>
      </div>
    </div>
  );
};

export default TestStatsCard;
